import axios from 'axios'
import config from '../config'

const createApi = ({ baseURL }) => {
  return axios.create({
    baseURL,
    timeout: 120000,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

const baseURL = config.urls.rx

const patientsApi = createApi({ baseURL: config.urls.rx })

export {
  patientsApi
}
